import { Link } from 'react-router-dom'
import SHOP_TYPE from '../../constants/shopTypes'
export default function CategoryProductCard({ product, shopType }) {
  const linkTo =
    shopType === SHOP_TYPE.retail
      ? `/retailers/${product.shopSlug}/products/${product.productSlug}`
      : `/wholesellers/${product.shopSlug}/products/${product.productSlug}/request-quote`
  return (
    <Link to={linkTo}>
      <div className="flex items-centre justify-between border border-secondary-200/30 rounded-lg p-3 mb-3 shadow-sm">
        <img
          src={product.primaryImageUrl}
          alt={product.name}
          className="w-14 h-14 object-cover rounded mr-4 flex-shrink-0"
        />
        <div className="flex-1">
          <p className="font-bold font-fontFamily text-base text-foreground-secondary">
            {product.name}
          </p>
          <p className="text-foreground-secondary text-base font-fontFamily font-normal">
            {product.shopName}
          </p>
        </div>
        {shopType === SHOP_TYPE.retail && (
          <div className="text-right flex-shrink-0">
            <p className="font-extrabold text-base text-secondary-700 font-fontFamily ">
              {product.priceText}
            </p>
          </div>
        )}
      </div>
    </Link>
  )
}
